// extracted by mini-css-extract-plugin
export default {"container":"AppWatermark_container__+i2al"};